import api from './api';

export const getCertifications = async () => {
  const { data } = await api.get('/certifications');
  return data;
};

export const createCertification = async (name, image_url, cert_url) => {
  const { data } = await api.post('/certifications', { name, image_url, cert_url });
  return data;
};

export const deleteCertification = async (id) => {
  const { data } = await api.delete(`/certifications/${id}`);
  return data;
};

export const updateCertificationMappings = async (id, mappings) => {
  const { data } = await api.put(`/certifications/${id}/mappings`, { mappings });
  return data;
};
